import {Form} from "react-bootstrap"
import {useTranslation} from "react-i18next"
import {Eexam} from "../types"

type Props = {value: Partial<Eexam>, onChange: (value: Partial<Eexam>) => void}

export default function EexamForm({value, onChange}: Props) {
    const {t} = useTranslation(["eexam"])

    return (
        <>
            <Form.Group className="mb-3">
                <Form.Label>{t("fields.titleDe")}</Form.Label>
                <Form.Control value={value.title?.de ?? ""} onChange={event => onChange({...value, title: {de: event.target.value, en: value.title?.en ?? ""}})}/>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t("fields.titleEn")}</Form.Label>
                <Form.Control value={value.title?.en ?? ""} onChange={event => onChange({...value, title: {de: value.title?.de ?? "", en: event.target.value}})}/>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t("fields.department")}</Form.Label>
                <Form.Control value={value.department ?? ""} onChange={event => onChange({...value, department: event.target.value})} placeholder={t("placeholders.objectId")}/>
                <Form.Text>{t("hints.departmentObjectId")}</Form.Text>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t("fields.draftingCourseId")}</Form.Label>
                <Form.Control type="number" value={value.draftingCourseId ?? ""} onChange={event => onChange({...value, draftingCourseId: event.target.value ? Number(event.target.value) : undefined})}/>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t("fields.moduleHandbookFile")}</Form.Label>
                <Form.Control value={value.moduleHandbookFile ?? ""} onChange={event => onChange({...value, moduleHandbookFile: event.target.value})}/>
            </Form.Group>
        </>
    )
}
